import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Auth0WebHeader from '@website-components/header';
import loggedin from 'modules/loggedin';
import { login } from 'modules/boot/sso';
import { injectGlobal } from 'styled-components';

const checkThemeFromHTMLClass = () => {
  const html = document.documentElement;
  const htmlHasClass = className => html.classList.contains(className);
  const isDarkTheme = htmlHasClass('header-dark') || htmlHasClass('theme-dark');

  return isDarkTheme ? 'dark' : 'light';
};

/* eslint-disable no-unused-expressions */
injectGlobal`
  .theme-dark header nav > div > a:nth-child(1), .theme-dark header nav li > div > h2 {
    color: #cdd2d4;
  }
  
  .theme-dark header nav > div > a:nth-child(2) {
    color: white;
  }
  
  .theme-dark header nav section > div > h4 {
    color: rgb(165, 168, 168);
  }
  
  .theme-dark header nav section > div p {
    color: rgb(205, 210, 212);
  } 
  
  .theme-dark header nav > div > a:hover {
    color: #ffffff; 
  }  
  
  .theme-dark header nav > ul > li:last-child > a {
    color: white;
  }    
`;
/* eslint-enable no-unused-expressions */

const signup = () => window.signup();

class Header extends Component {
  state = {
    logged: false,
  };

  componentDidMount() {
    /* eslint-env browser */
    loggedin.onChange(logged => {
      if (document.getElementsByClassName('login-link').length) {
        return;
      }

      this.setState({ logged });
    });
  }

  render() {
    const {
      theme,
      headerData
    } = this.props;
    const { logged } = this.state;
    const props = {};

    if (logged) {
      props.signupButtonLink = 'https://manage.auth0.com';
    } else {
      props.signupButtonOnClick = signup;
    }

    return <Auth0WebHeader
      headerData={headerData}
      theme={theme}
      talkToUsButtonLink="/contact-us"
      loginButtonOnClick={login}
      onFirstNavInteraction={() => window.metricsLib.track('header:navigation:interact')}
      {...props}
    />;
  }
}

Header.defaultProps = {
  headerData: null,
};

Header.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']).isRequired,
  headerData: PropTypes.shape(),
};

export default Header;

export { checkThemeFromHTMLClass };



// WEBPACK FOOTER //
// ./src/modules/header/Header.js